import React, {useState, createContext, useContext} from "react";

interface ResponseStatusType {
    responseStatus: boolean;
    formType: 'feedback' | 'payment';
    setResponseStatus: (status: boolean) => void;
    setFormType: (type: 'feedback' | 'payment') => void;
}

const ResponseStatusContext = createContext<ResponseStatusType | undefined>(undefined);

export const ResponseStatusProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [responseStatus, setResponseStatus] = useState<boolean>(false);
    const [formType, setFormType] = useState<'feedback' | 'payment'>('feedback');

    return (
        <ResponseStatusContext.Provider value={{responseStatus, formType, setResponseStatus, setFormType}}>
            {children}
        </ResponseStatusContext.Provider>
    );
}

export const useResponseStatus = (): ResponseStatusType => {
    const context = useContext(ResponseStatusContext);
    if (!context) {
        throw new Error("useResponseStatus must be used within a ResponseStatusProvider");
    }
    return context;
};
